import React, { useState, useEffect } from "react";
import { FiSave, FiTrash2 } from "react-icons/fi";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/website/redirect`;


const WebsiteRedirect = () => {
  const [redirectData, setRedirectData] = useState({
    from_url: "",
    to_url: "",
    status: "inactive",
    updated_at: "",
  });

  useEffect(() => {
    fetchRedirectData();
  }, []);

  // Yönlendirme verisini çek
  const fetchRedirectData = async () => {
    try {
      const resp = await axios.get(BASE_URL);
      if (!resp.data || Object.keys(resp.data).length === 0) {
        console.warn("🚨 Yönlendirme bulunamadı.");
        return;
      }
      setRedirectData(resp.data);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
      toast.error("Veri alınamadı!");
    }
  };

  // Input değişimini yönet
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRedirectData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Durumu değiştir ve tüm veriyi güncelle
  const toggleStatus = async () => {
    try {
      const newStatus = redirectData.status === "active" ? "inactive" : "active";

      const updatedData = {
        ...redirectData,
        status: newStatus, // Durumu değiştir
        updated_at: new Date().toISOString(),
      };

      await axios.put(BASE_URL, updatedData); // Sunucuya tüm veriyi gönder

      setRedirectData(updatedData); // Ekranı güncelle

      toast.success(`Durum "${newStatus === "active" ? "Aktif" : "Pasif"}" olarak güncellendi!`);
    } catch (error) {
      console.error("Durum güncellenemedi:", error);
      toast.error("Durum değiştirilemedi!");
    }
  };

  // Güncelleme işlemi
  const handleSave = async () => {
    if (redirectData.status === "inactive") {
      toast.warn("Pasif modda değişiklik yapılamaz!");
      return;
    }

    try {
      await axios.put(BASE_URL, redirectData);
      toast.success("Yönlendirme güncellendi!");
      fetchRedirectData(); // Güncellenmiş verileri tekrar çek
    } catch (error) {
      toast.error("Güncelleme başarısız!");
    }
  };

  // Yönlendirmeyi sıfırla
  const handleDelete = async () => {
    try {
      await axios.delete(BASE_URL);
      setRedirectData({ from_url: "", to_url: "", status: "inactive", updated_at: "" });
      toast.success("Yönlendirme sıfırlandı!");
    } catch (error) {
      toast.error("Silme işlemi başarısız!");
    }
  };

  return (
    <div className={`container mt-4 ${redirectData.status === "inactive" ? "disabled-overlay" : ""}`}>
      <ToastContainer />

      <div className="card card-body">
        {/* Durum Switch */}
        <div className="d-flex align-items-center justify-content-between mb-3">
 
          <div className="form-check form-switch">
            <input
              className="form-check-input custom-checkbox"
              type="checkbox"
              checked={redirectData.status === "active"}
              onChange={toggleStatus}
              style={{ cursor: "pointer", width: "50px", height: "24px" }}
            />
            <span className={`badge ms-2 ${redirectData.status === "active" ? "badge-success" : "badge-danger"}`}>
              {redirectData.status === "active" ? "Aktif" : "Pasif"}
            </span>
          </div>
        </div>

        {/* Son Güncellenme Tarihi */}
        <div className="text-start text-muted mb-3">
          Son Güncelleme: {redirectData.updated_at ? new Date(redirectData.updated_at).toLocaleString("tr-TR") : "Henüz güncellenmedi"}
        </div>

        {/* Yönlendirme URL */}
        <div className="mb-3">
          <label className="form-label fw-bold">Yönlendirme URL</label>
          <input
            type="text"
            className="form-control"
            name="to_url"
            value={redirectData.to_url || ""}
            onChange={handleChange}
            disabled={redirectData.status === "inactive"}
          />
        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary" onClick={handleSave} disabled={redirectData.status === "inactive"}>
            <FiSave /> Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebsiteRedirect;
